import React, { useEffect, useState } from "react";
import "./Main.css";
import data from "../data/health_insurance_2023.json";

const App = () => {
  const [init, setInit] = useState(false);
  const [funds] = useState(data);
  const [options, setOptions] = useState({
    state: {
      label: "Choose State",
      value: "",
    },
    tier: {
      label: "Choose Tier",
      value: "",
    },
    excess: {
      label: "Choose Excess",
      value: "",
    },
    scale: {
      label: "Single or Family?",
      value: "",
    },
  });

  const [allComplete, setAllComplete] = useState(false);

  useEffect(() => {
    setAllComplete(Object.values(options).every((opt) => opt.value !== ""));
    if (options?.scale?.value !== "") setInit(true);
  }, [options]);

  const results = funds
    .filter((val) => {
      return (
        (options.state.value === val.state ||
          val.state === "ALL" ||
          options.state.value === "Any") &&
        (options.tier.value === val.tier || options.tier.value === "Any") &&
        (options.excess.value.toString() === val.excess.toString() ||
          options.excess.value === "Any") &&
        (options.scale.value === val.scale || options.scale.value === "Any")
      );
    })
    .sort((a, b) => {
      const aPrem = a.premium;
      const bPrem = b.premium;

      if (!isNaN(aPrem) && !isNaN(bPrem)) {
        return aPrem - bPrem;
      }

      return 1;
    });

  const getOptions = (key) => {
    const options = funds
      .reduce((acc, val) => {
        if (acc.indexOf(val[key]) === -1 && val[key] !== "ALL") {
          acc.push(val[key]);
        }
        return acc;
      }, [])
      .sort((a, b) => {
        if (isNaN(a) && isNaN(b)) {
          if (a === "Gold") {
            return 1;
          }
          return a.localeCompare(b);
        }
        return a - b;
      });

    return options;
  };

  return (
    <div className="health-insurance-interactive__app">
      <div className="health-insurance-interactive__ed-header">
        <div className="health-insurance-interactive__ed-header-left">
          Health Fund Calculator
          <div className="health-insurance-interactive__hide-mobile">
            Select from the menu's below to find the best health cover for you.
          </div>
        </div>
        <div className="health-insurance-interactive__ed-header-image"></div>
        <div className="health-insurance-interactive__show-mobile health-insurance-interactive__mobile-tagline">
          Select from the menu's below to find the best health cover for you.
        </div>
      </div>
      <div className="health-insurance-interactive__ed-options">
        {Object.keys(options).map((key, index) => (
          <select
            key={index}
            className={`health-insurance-interactive__ed-option ${
              options[key].value !== ""
                ? "health-insurance-interactive__ed-option--selected"
                : ""
            }`}
            value={options[key].value}
            onChange={(e) => {
              const updatedOptions = { ...options };
              updatedOptions[key].value = e.target.value;
              setOptions(updatedOptions);
            }}
          >
            <option value="">{options[key].label}</option>
            {["tier", "excess"].includes(key) && (
              <option value="Any">Any</option>
            )}
            {getOptions(key).map((optionName, optionKey) => (
              <option key={optionKey} value={optionName}>
                {!isNaN(optionName) ? `$${optionName}` : optionName}
              </option>
            ))}
          </select>
        ))}
      </div>

      {init ? (
        <div className="health-insurance-interactive__ed-results">
          {allComplete && results.length > 0 ? (
            <table>
              <thead>
                <tr>
                  <th>Fund</th>
                  <th>Policy</th>
                  <th>Premium</th>
                </tr>
              </thead>
              <tbody>
                {results.map((result, key) => (
                  <tr key={key}>
                    <td>{result.fund}</td>
                    <td>{result.name}</td>
                    <td>
                      {!isNaN(result.premium)
                        ? "$" + Number(result.premium).toFixed(2)
                        : result.premium.toString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div style={{ textAlign: "center", padding: "10px" }}>
              There are no results for this search, modify your selections and
              try again
            </div>
          )}
        </div>
      ) : (
        <></>
      )}

      <div className="health-insurance-interactive__ed-footer">
        This health fund tool displays premiums, exclusive of the government's
        private health insurance tax rebate. Not everyone is entitled to this
        rebate and it varies depending on your age. This search tool does not
        show policies that cover non-student dependents under the age of 31 or
        dependents with a disability. The tool also shows some policies which
        are only available to company employees and their families and corporate
        clients.
      </div>
    </div>
  );
};

export default App;
